import { axiosV2 } from 'interceptors/axios';
import { downloadBlob } from 'utils/downloadBlob';

type DownloadTradingOfferOperationsXlsxProps = {
  fileName: string;
  societyId: string;
  tradingOfferId?: string;
  partnerId?: string;
  tradingOfferOperationStatus?: string;
  tradingOfferType?: string;
};

export const downloadTradingOfferOperationsXlsx = async ({
  fileName,
  societyId,
  tradingOfferId,
  partnerId,
  tradingOfferOperationStatus,
  tradingOfferType,
}: DownloadTradingOfferOperationsXlsxProps) => {
  const { data } = await axiosV2.get<Blob>('/tradingOfferOperations/xlsx', {
    params: {
      societyId,
      ...(tradingOfferId ? { tradingOfferId } : {}),
      ...(partnerId ? { partnerId } : {}),
      ...(tradingOfferOperationStatus
        ? { tradingOfferOperationStatus }
        : {}),
      ...(tradingOfferType ? { tradingOfferType } : {}),
    },
    responseType: 'blob',
  });

  downloadBlob(data, `${fileName}.xlsx`);
};
